var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GCheckListDetail',{staticClass:"buyer-favorites",attrs:{"loading":_vm.loading,"checklist":_vm.checklist},on:{"check":_vm.onCheck}})}
var staticRenderFns = []

export { render, staticRenderFns }